import Header from '@/components/Header';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';

// import Forbiden403 from '@/pages/403';
import UseWalletConnectHook from '@/hooks/useWalletconnect';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import TransactionConfirmationModal from '@/components/TransactionConfirmationModal';

import { routes } from '@/routes';
import PageWrapper from './components/Page/PageWrapper';
import SignatureModal from './components/SignatureModal';
import useSignature from './hooks/useSignature';

const Container = styled.div`
    width: 100vw;
    background-size: 100% auto;
    background-image: url(${require('@/assets/images/bg-pc.png')});
    background-color: #112240;
    overflow: hidden;
`;

function App() {
    const { i18n } = useTranslation();
    const location = useLocation();
    const history = useHistory();
    const { showSignatureModal, closeSignatureModal, handleSignSuccess } =
        useSignature();

    useEffect(() => {
        const container = document.getElementById('globalContainer');
        container?.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <>
            <UseWalletConnectHook />
            <TransactionConfirmationModal />
            <SignatureModal
                isOpen={showSignatureModal}
                onClose={closeSignatureModal}
                onSuccess={handleSignSuccess}
            />
            {/* <GlobalLoading /> */}
            <Container id="globalContainer">
                <Header />
                <Switch>
                    {routes.map(({ path, component: Component, exact }) => (
                        <Route key={path} exact={exact} path={path}>
                            <PageWrapper>
                                <Component />
                            </PageWrapper>
                        </Route>
                    ))}
                </Switch>
            </Container>
        </>
    );
}

export default observer(App);
